/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import type Status from '../../common/models/Status';
import type Mithril from 'mithril';

export interface StatusSelectAttrs extends ComponentAttrs {
	selected?: Status | false | null;
	onSelect: (status: Status) => void;
}

export default class StatusSelect<CustomAttrs extends StatusSelectAttrs = StatusSelectAttrs> extends Component<CustomAttrs> {
	protected statuses!: Status[];

	oninit(vnode: Mithril.Vnode<CustomAttrs, this>): void {
		super.oninit(vnode);

		this.statuses = app.store.all<Status>('book_status');
	}

	view(): Mithril.Children {
		const { selected, onSelect } = this.attrs;

		return (
			<div className="StatusSelect">
				<div className="StatusSelect-header">{app.translator.trans('glowingblue-orell-bookshelf.forum.article_dropdown.status_label')}</div>
				{this.statuses.map((status) => (
					<div className={`StatusSelect-status ${selected && status.id() === selected.id() ? 'isSelected' : ''}`} onclick={() => onSelect(status)}>
						<span className="StatusSelect-radio_icon">
							{selected && status.id() === selected.id() ? icon('far fa-dot-circle') : icon('far fa-circle')}
						</span>
						<span className="StatusSelect-radio_label">{status.name()}</span>
					</div>
				))}
			</div>
		);
	}
}
